import { useSelector } from 'react-redux';
import RussianBlockedBanner from 'pricing-pages-ui-components/banners/RussianBlockedBanner';
import { useGlobalLoading } from '../../hooks/loadingHooks';
import { isRussianBlockedSelector } from '../../selectors/PurchaseMotionSelectors';
import StarterPromotion2025BannerWrapper from './StarterPromotion2025BannerWrapper';
import { TrialDiscountBanner } from './TrialDiscountBanner';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BannerHierarchySection = ({
  screen
}) => {
  const isAppReady = useGlobalLoading();
  const isRussianBlocked = useSelector(isRussianBlockedSelector);
  if (!isAppReady) {
    return null;
  }
  if (isRussianBlocked) {
    return /*#__PURE__*/_jsx(RussianBlockedBanner, {});
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(TrialDiscountBanner, {
      screen: screen
    }), /*#__PURE__*/_jsx(StarterPromotion2025BannerWrapper, {
      screen: screen
    })]
  });
};
export default BannerHierarchySection;